import React, { useState } from 'react';
import Submenu from './Submenu';
import { FiChevronDown } from 'react-icons/fi';
import { NavLink as RRDNavLink } from 'react-router-dom';

const NavLink = ({ isActive, ...restProps }) => {
  return (
    <RRDNavLink
      {...restProps}
      className={({ isActive: rrdIsActive }) => {
        return rrdIsActive || isActive ? 'menu__link menu__link--is-active' : 'menu__link';
      }}
    />
  );
};

export default function MenuItem({ item }) {
  const [isExpanded, setIsExpanded] = useState(false);

  const pathname = window.location.pathname;

  const subroutes = item?.submenu?.nav.map(item => item.route.split('/')[1]);

  const hasRoute = item?.route !== '/' && pathname.includes(item?.route);
  const hasSubroutes = pathname !== '/' && subroutes?.includes(pathname.split('/')[1]);

  const handleShowSubmenu = e => {
    e.stopPropagation();
    setIsExpanded(!isExpanded);
  };

  const showMenuItem = item?.submenu?.nav?.some(item => item?.visible);

  if (!item?.submenu)
    return (
      <li className="menu__item">
        <NavLink
          to={item?.route}
          isActive={hasRoute}
        >
          {item?.icon} {item?.label && <span className="menu__label">{item?.label}</span>}
        </NavLink>
      </li>
    );

  return (
    showMenuItem && (
      <li
        className={!isExpanded ? 'menu__item menu__item--has-submenu' : 'menu__item menu__item--has-submenu menu__item--is-expanded'}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <span
          className={hasSubroutes ? 'menu__link menu__link--is-active' : 'menu__link'}
          onClick={handleShowSubmenu}
        >
          {item?.icon} {item?.submenu?.title && <span className="menu__label">{item?.submenu?.title}</span>} <FiChevronDown className="menu__arrow" />
        </span>

        <Submenu data={item?.submenu} />
      </li>
    )
  );
}
